/**
 * Formats cents as money using a Shopify money_format string (e.g. "${{amount}}").
 * @param {number} cents - Amount in the shop's smallest currency unit.
 * @param {string} format - Shopify money format string.
 * @returns {string} Formatted money string.
 */
function vipFormatMoney(cents, format) {
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === 'undefined' ? 2 : precision;
    thousands = typeof thousands === 'undefined' ? ',' : thousands;
    decimal = typeof decimal === 'undefined' ? '.' : decimal;

    if (Number.isNaN(number)) return '0';

    const fixed = (number / 100.0).toFixed(precision);
    const parts = fixed.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  const match = formatString.match(placeholderRegex);
  const placeholder = match ? match[1] : 'amount';
  let value;

  switch (placeholder) {
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ', '');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return match ? formatString.replace(placeholderRegex, value) : value;
}

/**
 * Keeps the PDP VIP savings card in sync with the selected variant price and quantity.
 */
class VipSavings {
  constructor() {
    this.cardSelector = '[data-vip-savings-card]';
    this.boundUpdate = this.update.bind(this);

    document.addEventListener('change', (evt) => {
      if (evt.target.matches('.js-product-form-main input[name="quantity"]')) this.boundUpdate();
    });
    document.addEventListener('on:variant:change', this.boundUpdate);

    this.update();
  }

  update() {
    document.querySelectorAll(this.cardSelector).forEach((card) => {
      const unitPrice = Number(card.dataset.unitPrice) || 0;
      const quantityInput = document.querySelector('.js-product-form-main input[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      const savings = Math.round(unitPrice * quantity * 0.05);
      const amountEl = card.querySelector('[data-vip-savings-amount]');
      if (amountEl) amountEl.textContent = vipFormatMoney(savings, theme.settings.moneyFormat);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new VipSavings());
